module.exports = __webpack_public_path__ + "static/media/hepsiburada.0276593f.png";